export default "__VITE_ASSET__CM6omFc9__"